import { render } from "./LevelTwoChartOfAccountsPage.vue?vue&type=template&id=cada6baa&scoped=true"
import script from "./LevelTwoChartOfAccountsPage.vue?vue&type=script&lang=js"
export * from "./LevelTwoChartOfAccountsPage.vue?vue&type=script&lang=js"

import "./LevelTwoChartOfAccountsPage.vue?vue&type=style&index=0&id=cada6baa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cada6baa"]])

export default __exports__